import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getAccountManagers } from 'api/account-manager';
import Staff from './AccountManager';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './account-manager.config';

const AccountManagers = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [accountManagers, setAccountManagers] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const fetchAccountManagers = async () => {
    const { data } = await getAccountManagers(pageNumber, pageSize);

    setAccountManagers(data);
    setRowCount(data.pagination.total);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchAccountManagers();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/account-managers/${id}`);
    setModalOpen(true);
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/account-managers');
    fetchAccountManagers();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  const handleAdd = () => {
    history.push('/account-managers/add');
    setModalOpen(true);
    fetchAccountManagers();
  };

  return (
    <>
      <PageTemplate
        data={get(accountManagers, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={rowCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/:id`}>
          <Staff
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default AccountManagers;
